import { render, staticRenderFns } from "./employeeInboxRep.vue?vue&type=template&id=f81ef242&"
import script from "./employeeInboxRep.vue?vue&type=script&lang=js&"
export * from "./employeeInboxRep.vue?vue&type=script&lang=js&"
import style0 from "./employeeInboxRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports